<wide-dialog-wrapper
  [backgroundColor]="'#9FC5E8'"
  [dialogTitle]="'Manage Quote'"
  [disabled]="linkInvalid"
  [deleteTitle]="'Delete'"
  [deleteText]="deleteText"
  [delete]="true"
  [successLabel]="'DONE'"
  (onSubmit)="save()"
  (onDelete)="delete()"
>
   <div class="top-line">
    <div class="resource-name">
      <icon [icon]="'workforce48'"></icon>
      <h5>Resource's name: </h5>
      <div class="name">{{ resource?.name || 'Unnamed Resource' }}</div>
    </div>
    <div style="flex:1"></div>
    <traffic-light-dropdown *ngIf="quoteInfo" class="quote-status"
      [selected]="quoteInfo.quoteStatus"
      [colorObject]="colorsByStatus"
      [readOnly]="false"
      [selections]="statusOptions"
      (select)="changeQuoteStatus($event)"
    ></traffic-light-dropdown>
  </div>


@if(quote){
  <tip-text [type]="'tip'" [head]="'Tip:'" [body]="'To make quote management easier, add a service type and submission deadline before sending the RFQ.'"></tip-text>
  <div class="header">
    <h5>Submission deadline: </h5>
    <date-picker (onDateChange)="saveDeadline($event)" [pickedDate]="quote.submissionDeadline"></date-picker>
    <div style="flex:1"></div>
    <div class="hint">*Internal use only</div>
    <h5>Services type: </h5>
    <joi-input  [(model)]="quote.quoteType" [placeholder]="'Services type...'" (joiChange)="updateQuote()"></joi-input>
  </div>
  <div class="hint last-submitted" *ngIf="quote.lastSubmitted">Last submitted: {{ quote.lastSubmitted | date:"EEEE d LLLL y" }}</div>

  <title-toggle-wrapper
    class="receive-toggle"
    *ngIf="{ off: !quoteInfo.status || quoteInfo.status === 'Off' } as vars"
    [title]="'Receive quote information'"
    [hideBottom]="vars.off"
    [toggleOn]="!vars.off"
    (toggle)="submitToggle($event)"
    >
    <div style="margin-bottom: 20px">Share webform to receive a quote.</div>
    <div style="margin-bottom: 10px">YOUR SHAREABLE WEBFORM:</div>
    <share-code 
      [shareType]="'quote'"
      [shareCode]="quote.id" 
      [hideTitle]="true"
      [disabled]="!['Active', 'Submitted'].includes(quoteInfo.status)"
      [hideJson]="true"
      [emailGenerator]="emailGenerator.bind(this)"
      [selectedStatus]="quoteInfo.status"
      (changeStatus)="changeInfoStatus($event)">
    </share-code>

    <div class="hint" style="margin-top: 10px;">
      Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.
    </div>

  </title-toggle-wrapper>

  <div class="quote-info">
    <div class="left">
      <joi-input #sectionTitle class="big-title" [type]="'textarea'" [(model)]="quote.name" [placeholder]="'Quote Name...'" (joiChange)="updateQuote(); changeQuoteInfoQuoteName()" ></joi-input>
      <h5>NOTES / DESCRIPTION</h5>
      <input-editor 
        class="quote-notes"
        [object]="quote" 
        [prop]="'notes'" 
        [placeholder]="'Quote notes / description...'"
        (changed)="updateQuote(true)"
      ></input-editor>
    </div>
    <div class="right">
      <div class="info-line">
        <div class="field-name">Quote Ref #: </div>
        <div style="flex:1"></div>
        <joi-input
          [fixedWidth]="true"
          [(model)]="quote.quoteRef" 
          [placeholder]="'Reference no...'" 
          (joiChange)="updateQuote(true)"
        ></joi-input> 
      </div>
      <edit-link [title]="'Quote Link:'" [link]="quote.quoteLink" (saveLink)="quote.quoteLink = $event; updateQuote()"></edit-link>
      <div style="flex:1"></div>
    </div>
  </div>



  <budget-section *ngIf="!!quote && !!budget && !!gridData && !!scheduleGridData"
    #budgetSection
    [section]="quote"
    [budgetCurrency]="budget.currency"
    [hideTitle]="true"
    [isRevenue]="false"
    [single]="true"
    [gridData]="gridData"
    [scheduleGridData]="scheduleGridData"
    (saveSection)="updateQuote()"
    (changeSectionSettingDefaults)="saveSectionSettingDefaults($event)"
    (nameChange)="updateInfo()"
  ></budget-section> 
}


</wide-dialog-wrapper>

